export enum AnnotationStateType {
  Blank, // not yet annotating
  Annotating,
  Annotated,
}
